import { useTranslation } from '@cobliteam/i18n';
import Environment from '@cobliteam/react-environments';
import { Button } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { format } from '@cobliteam/utils/date';
import { Link } from 'react-router-dom';

const env = Environment.getInstance().getEnvironment();

interface VehicleCardMapProps {
  title?: string;
  latitude?: number | null;
  longitude?: number | null;
  updatedAt?: number | null;
  linkTo: string;
  onLinkClick?: () => void;
}

const VehicleCardMap = ({ latitude, longitude, updatedAt, linkTo, title, onLinkClick }: VehicleCardMapProps) => {
  const { t } = useTranslation('global-search');

  const isLocationValid = latitude && longitude;
  if (!isLocationValid) return null;

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex flex-row items-center justify-between'>
        <div className='flex flex-col'>
          <div className='flex flex-row items-center gap-1'>
            <div className='font-medium text-sm'>{title || t('card_map.vehicle_location_title')}</div>
          </div>
          <div className='flex flex-row gap-1 text-gray-9'>
            <div className='text-xs'>{t('card_map.last_update')}</div>
            <div className='text-xs'>{updatedAt ? format(updatedAt, 'dd/MM/yyyy HH:mm') : '---'}</div>
          </div>
        </div>
        <div>
          <Link to={linkTo} onClick={onLinkClick}>
            <Button className='h-6 text-sm' variant='link' size='sm' startIcon={<Icon name='external-link' />}>
              {t('card_map.view_on_map')}
            </Button>
          </Link>
        </div>
      </div>
      <div className='h-[200px] w-full overflow-hidden rounded-sm'>
        <Link to={linkTo} onClick={onLinkClick}>
          <img
            width='328'
            className='h-full w-full object-cover transition-all duration-300 hover:scale-110'
            src={`https://maps.googleapis.com/maps/api/staticmap?auto=${latitude},${longitude}&zoom=13&scale=2&size=656x328&maptype=roadmap&format=png&markers=${latitude},${longitude}&key=${env.googleMapsKey}`}
            alt='Google maps vehicle location'
          />
        </Link>
      </div>
    </div>
  );
};

export default VehicleCardMap;
